import { useArrayConstants } from "@/app/hooks/useArrayConstants";
import { useBreedConstants } from "@/app/hooks/useBreedConstants";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { useUtils } from "@/app/hooks/useUtils";
import { useAppSelector } from "@/app_redux/hooks/root_hook";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import { useEffect, useState } from "react";

const ClientInformation = () => {
  const { getRouteKey } = useRouter();
  const { formatDate } = useUtils();
  const { routeState } = useRouteInfo(getRouteKey("CUSTOMER_PROFILE", "id"));
  const { customerDetails, petDetails } = routeState.state as ICustomerProfileState;
  const { catBreeds, dogBreeds, giantBreeds } = useBreedConstants();


  // State to store form values
  const [formData, setFormData] = useState({
    petName: "",
    petId: "",
    petSpecies: "",
    petgender: "",
    petBreed: "",
    ownerName: "",
    contactNumber: "",
    useremail: "",
    date: null,
  });

  // Function to handle input changes
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>, field: string) => {
    setFormData({ ...formData, [field]: e.target.value });
  };

  const breadDetection = (petSpeciesId, petBreedId) => {
    if (petSpeciesId === "1") {
      const filteredCatBreeds = dogBreeds.filter((catBreed) => catBreed.id === petBreedId);
      return filteredCatBreeds[0]?.pet_breed;
    } else if (petSpeciesId === "2") {
      const filteredCatBreeds = catBreeds.filter((catBreed) => catBreed.id === petBreedId);
      return filteredCatBreeds[0]?.pet_breed;
    } else if (petSpeciesId === "15") {
      const filteredGiantBreeds = giantBreeds.filter((giantBreed) => giantBreed.id === petBreedId);
      return filteredGiantBreeds[0]?.pet_breed;
    } else {
      return "Other";
    }
  };

  useEffect(() => {
    if (petDetails && customerDetails) {
      setFormData((prevData) => ({
        ...prevData,
        petName: petDetails?.name,
        petId: petDetails?.id,
        petSpecies: petDetails?.pet_species_type_id === "1" ? "DOG" : "CAT",
        petgender: petDetails?.gender,
        petBreed: breadDetection(petDetails?.pet_species_type_id, petDetails?.pet_breed_id),
        ownerName: customerDetails?.name,
        contactNumber: customerDetails?.mobile,
        useremail: customerDetails?.email,
        date: formatDate(),
      }));
    }
  }, [customerDetails, petDetails]);

  return (
    <div className="mb-2">
      <div className=" bg-white">
        <table className="w-full border-none flex  ">
          <tbody>
            {[
              { label: "Client Name", key: "ownerName" },
              { label: "Client Email ID", key: "useremail" },
              { label: "Pet Name", key: "petName" },
              { label: "Pet id", key: "petId" },
              { label: "Pet Gender", key: "petgender" },
              { label: "Test Date", key: "date" },
              { label: "Species", key: "petSpecies" },
            ].map(({ label, key }) => (
              <tr key={key} className="">
                <td className="  font-semibold  text-xs">{label}:</td>
                <td className=" ">
                  <input
                    type="text"
                    className="border  w-[200px] p-1 focus:outline-none text-xs"
                    value={formData[key as keyof typeof formData]}
                    onChange={(e) => handleInputChange(e, key)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <style>
        {`
          @media print {
          
            input {
              border: none;
            }
          }
        `}
      </style>
    </div>
  );
};

export default ClientInformation;
